import React from 'react'
import { Box, Dialog, DialogActions, DialogContent, Button, Typography, IconButton } from "@material-ui/core";
import { Message } from "./type";
import { CheckCircle, Close, Error, GetApp, InsertDriveFile, Schedule, Delete } from "@material-ui/icons";
import { appURL } from '../../services/auth/jwt/config';

const ChatMessageBubble = ({ message, isOwn }: { message: Message; isOwn: boolean }) => {
    const [imageModalOpen, setImageModalOpen] = React.useState(false);

    const getDaysUntilDeletion = () => {
        const createdDate = new Date(message.created_at);
        const currentDate = new Date();
        const diffTime = currentDate.getTime() - createdDate.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        return 20 - diffDays;
    };

    const isFileDeleted = () => {
        return getDaysUntilDeletion() < 0;
    };

    const isImage = (filename: string) => {
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
        return imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
    };

    const handleDownload = () => {
        if (message.file_url) {
            const link = document.createElement('a');
            link.href = message.file_url;
            link.download = message.content;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const getStatusIcon = () => {
        switch (message.status) {
            case 'sending':
                return <Schedule style={{ fontSize: '0.85rem', opacity: 0.7 }} />;
            case 'sent':
            case 'read':
                return <CheckCircle style={{ fontSize: '0.85rem', opacity: 0.7 }} />;
            case 'error':
                return <Error style={{ fontSize: '0.85rem', opacity: 0.7 }} />;
            default:
                return null;
        }
    };

    return <Box
        display="flex"
        width="100%"
        justifyContent={isOwn ? 'flex-end' : 'flex-start'}
        mb={2}
        style={{ opacity: message.status === 'sending' ? 0.7 : 1 }}
    >
        <Box
            style={{
                borderRadius: 12,
            }}
            p={2}
            sx={{
                maxWidth: '75%',
                minWidth: '20%',
                bgcolor: isOwn ? 'primary.main' : 'grey.200',
                color: isOwn ? 'white' : 'text.primary',
            }}
        >
            {message.type === 'text' ? <Typography variant="body2">
                {message.content}
            </Typography> : isImage(message.content) && message.file_url ? <>
                {isFileDeleted() ? (
                    <Box>
                        <Box
                            display="flex"
                            flexDirection="row"
                            gridGap={1}
                            alignItems="center"
                        >
                            <Delete fontSize="small" />
                            <Box>
                                <Typography variant="body2" style={{ textDecoration: 'line-through', fontWeight: 500, wordBreak: 'break-all' }}>
                                    {message.content}
                                </Typography>
                                <Typography variant="caption" style={{ opacity: 0.7, display: 'block' }}>
                                    Imagem deletada
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <>
                        <Box
                            onClick={() => setImageModalOpen(true)}
                            style={{
                                cursor: 'pointer',
                                position: 'relative',
                                borderRadius: 8,
                                overflow: 'hidden',
                                maxWidth: '100%'
                            }}
                        >
                            <img
                                src={`${appURL}${message.file_url}`}
                                alt={message.content}
                                style={{
                                    width: '100%',
                                    maxWidth: 300,
                                    height: 'auto',
                                    display: 'block',
                                    borderRadius: 8
                                }}
                            />
                        </Box>
                        <Typography variant="caption" style={{ opacity: 0.7, display: 'block', marginTop: '0.5rem' }}>
                            {message.content}
                        </Typography>
                        <Typography 
                            variant="caption" 
                            style={{ 
                                display: 'block', 
                                marginTop: '0.5rem', 
                                opacity: 0.8,
                                fontStyle: 'italic',
                                color: getDaysUntilDeletion() <= 5 ? '#ff9800' : 'inherit'
                            }}
                        >
                            ⚠️ Será deletado em {getDaysUntilDeletion()} {getDaysUntilDeletion() === 1 ? 'dia' : 'dias'}
                        </Typography>

                        <Dialog
                            open={imageModalOpen}
                            onClose={() => setImageModalOpen(false)}
                            maxWidth="lg"
                        >
                            <Box style={{ position: 'relative' }}>
                                <IconButton
                                    onClick={() => setImageModalOpen(false)}
                                    style={{
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        color: 'white',
                                        zIndex: 1
                                    }}
                                    size="small"
                                >
                                    <Close />
                                </IconButton>
                            </Box>
                            <DialogContent style={{ padding: 0 }}>
                                <img
                                    src={`${appURL}${message.file_url}`}
                                    alt={message.content}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        maxHeight: '80vh',
                                        objectFit: 'contain'
                                    }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleDownload} color="primary" startIcon={<GetApp />}>
                                    Baixar
                                </Button>
                                <Button onClick={() => setImageModalOpen(false)}>
                                    Fechar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </>
                )}
            </> : <Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    gridGap={1}
                    alignItems="center"
                >
                    {isFileDeleted() ? <Delete fontSize="small" /> : <InsertDriveFile fontSize="small" />}
                    <Box>
                        <Typography variant="body2" style={{ textDecoration: isFileDeleted() ? 'line-through' : 'underline', fontWeight: 500, wordBreak: 'break-all' }}>
                            {message.content}
                        </Typography>
                        <Typography variant="caption" style={{ opacity: 0.7, display: 'block' }}>
                            {isFileDeleted() ? 'Anexo deletado' : 'Anexo'}
                        </Typography>
                    </Box>
                </Box>
                {message.type === 'file' && !isFileDeleted() && (
                    <Typography 
                        variant="caption" 
                        style={{ 
                            display: 'block', 
                            marginTop: '0.5rem', 
                            opacity: 0.8,
                            fontStyle: 'italic',
                            color: getDaysUntilDeletion() <= 5 ? '#ff9800' : 'inherit'
                        }}
                    >
                        ⚠️ Será deletado em {getDaysUntilDeletion()} {getDaysUntilDeletion() === 1 ? 'dia' : 'dias'}
                    </Typography>
                )}
            </Box>}
            <Typography
                variant="caption"
                display="block"
                style={{ marginTop: '0.5rem', opacity: 0.7, fontSize: '0.65rem', textAlign: 'right' }}
            >
                <Box display="flex" alignItems="center" justifyContent="flex-end" style={{ gap: '0.5rem' }}>
                    {new Date(message.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    {isOwn && getStatusIcon()}
                </Box>
            </Typography>
        </Box>
    </Box>
};

export default ChatMessageBubble